import { render, staticRenderFns } from "./Demo_Districts.vue?vue&type=template&id=400801a4&scoped=true&"
import script from "./Demo_Districts.vue?vue&type=script&lang=js&"
export * from "./Demo_Districts.vue?vue&type=script&lang=js&"
import style0 from "./Demo_Districts.vue?vue&type=style&index=0&id=400801a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400801a4",
  null
  
)

export default component.exports